import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { careersApi } from "../../services/careersApi";
import { useLocalization } from "../../hooks/useLocalization";
import { PublicHeader } from "../../components/PublicHeader";
import { JobPostingDetail } from "../../components/careers/JobPostingDetail";

export default function CareerJobDetailPage() {
  const { jobId } = useParams();
  const { t } = useLocalization();
  const [job, setJob] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    careersApi.getJob(jobId).then((r) => setJob(r.data)).catch(() => setNotFound(true));
  }, [jobId]);

  if (notFound) {
    return (
      <div className="min-h-screen bg-white text-blue-950 flex flex-col items-center justify-center gap-4" data-testid="careers-job-not-found">
        <p className="text-gray-500">{t("careers.noJobsOpen")}</p>
        <Link to="/careers" className="text-amber-500 font-semibold hover:underline">{t("careers.backToJobs")}</Link>
      </div>
    );
  }
  if (!job) return <div className="min-h-screen bg-white" data-testid="career-job-detail-loading" />;

  return (
    <div className="min-h-screen w-full bg-white text-blue-950" data-testid="career-job-detail-page">
      <PublicHeader />
      <header className="max-w-6xl mx-auto px-4 sm:px-6 pt-6 sm:pt-8 pb-8 sm:pb-10">
        <Link to="/careers" data-testid="back-to-jobs-link" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-blue-950 mb-6 transition-colors">
          <ArrowLeft size={14} /> {t("careers.backToJobs")}
        </Link>
      </header>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-12 sm:pb-16">
        <JobPostingDetail job={job} />
      </section>
    </div>
  );
}
